import { createContext } from 'react'

/**
 * @description Context for extended firebase instance created
 * by react-redux-firebase
 */
const ReactReduxFirebaseContext = createContext(null)

export default ReactReduxFirebaseContext
